import { render, staticRenderFns } from "./PbDashboardGroups.vue?vue&type=template&id=caa91af2&"
import script from "./PbDashboardGroups.vue?vue&type=script&lang=js&"
export * from "./PbDashboardGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports